import React, { forwardRef, useImperativeHandle } from 'react';
import { useDropdown } from './hooks/useDropdown';
const DropdownButton = forwardRef(function Button({ children, testId = 'store-dropdown-button', ...otherProps }, ref) {
    const { toggle, dropdownButtonRef, isOpen, id } = useDropdown();
    useImperativeHandle(ref, () => dropdownButtonRef.current, [
        dropdownButtonRef,
    ]);
    return (React.createElement("button", Object.assign({ "data-store-dropdown-button": true, onClick: toggle, "data-testid": testId, ref: dropdownButtonRef, "aria-expanded": isOpen, "aria-haspopup": "menu", "aria-controls": id }, otherProps), children));
});
export default DropdownButton;
//# sourceMappingURL=DropdownButton.js.map